import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.object.to-string.js";
import { ERROR_DATA } from "@/js/forms.js";
import Confirm from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
import UploaderV2 from "@/components/default/UploaderV2.vue";
export default {
  name: "RegionSubImageUploadModal",
  components: {
    Confirm: Confirm,
    ErrorModal: ErrorModal,
    UploaderV2: UploaderV2
  },
  props: {
    regionSub: Object,
    loggedUserData: Object
  },
  data: function data() {
    return {
      dialog: false,
      addingImage: {
        isConfiguring: false,
        url: "".concat(process.env.VUE_APP_API_URL, "/v1/regions/region-subs/upload-image"),
        uploaderFiles: [],
        isPending: false
      },
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    addingImageCanBeSubmitted: function addingImageCanBeSubmitted() {
      var _this$addingImage$upl;
      return ((_this$addingImage$upl = this.addingImage.uploaderFiles) === null || _this$addingImage$upl === void 0 ? void 0 : _this$addingImage$upl.length) > 0;
    },
    addingImageFormWithouValidNormalized: function addingImageFormWithouValidNormalized() {
      return {
        regionSubId: +this.regionSub.id
      };
    },
    isAnyActionInProgress: function isAnyActionInProgress() {
      return this.addingImage.isPending;
    },
    isAnySubFormInProgress: function isAnySubFormInProgress() {
      return this.addingImage.isConfiguring;
    }
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this.startAddingImage();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    startAddingImage: function startAddingImage() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this2.addingImage.uploaderFiles = [];
              _this2.addingImage.isConfiguring = true;
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    cancelAddingImage: function cancelAddingImage() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this3.close();
            case 1:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    addingImageSyncFiles: function addingImageSyncFiles(uploaderFiles) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this4.addingImage.uploaderFiles = _toConsumableArray(uploaderFiles);
            case 1:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    saveAddingImage: function saveAddingImage() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this5.addingImage.isPending = true;
              _this5.$refs.uploaderAddingImage.uploadAll(true);
            case 2:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    addingImageUploadSuccess: function addingImageUploadSuccess(response) {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this6.$emit("uploaded");
              _this6.$nextTick(function () {
                _this6.addingImage.isPending = false;
                _this6.addingImage.isConfiguring = false;
              });
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    addingImageUploadFailed: function addingImageUploadFailed() {
      this.addingImage.isPending = false;
    },
    open: function open() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this7.resetData();
              _this7.dialog = true;
              _this7.startAddingImage();
              return _context7.abrupt("return", new Promise(function (resolve, reject) {
                _this7.resolve = resolve;
                _this7.reject = reject;
              }));
            case 4:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    close: function close() {
      if (!this.isAnyActionInProgress) {
        this.dialog = false;
        this.resetData();
        this.$emit("closed");
      }
    },
    resetData: function resetData() {
      this.addingImage.uploaderFiles = [];
    }
  }
};